export default "__VITE_ASSET__3412b58f__"